import { useContext, useEffect } from "react";

import useFetch from "../useFetch";
import { LoaderContext } from "src/context/loaderContext";

import { AddCaseProps } from "src/pages/addCase/types";
import { APIEndpoints } from "src/types/apiTypes";
import { AuthContext } from "src/context/authContext";

import { ToastContext } from "src/context/toastContext";
import { ToastTypes } from "src/types";
import { CaseContext } from "src/context/caseContext";



export function useDraftCaseFunc() {
  const { setLoader, hideLoader } = useContext(LoaderContext)
  const { userData, updateUserData } = useContext(AuthContext)
  const { showToast } = useContext(ToastContext)
  const { draftCaseId, getCaseDraftListing, updateCaseDraftStatus, updateDraftCaseId } = useContext(CaseContext)




  const { loading: saveDraftLoader, data: saveDraftRes, error: saveDraftErr, mutate: callAPItoSaveDraft, removeErrorAndData: clearSaveDraftData } = 
    useFetch<{ status: number; success: boolean; case_draft_id: number; }>(APIEndpoints.SAVE_CASE_DRAFT)

  const { loading: updateDraftLoader, data: updateDraftRes, error: updateDraftErr, mutate: callAPItoUpdateDraft, removeErrorAndData: clearUpdateDraftData } = 
    useFetch<{ status: number; success: boolean; }>(APIEndpoints.UPDATE_CASE_DRAFT)

  useEffect(() => {
    if (saveDraftRes || saveDraftErr || updateDraftRes || updateDraftErr) {
      hideLoader()

      if (saveDraftRes) {
        if (saveDraftRes.success) {
          showToast(["Draft saved successfully!!"], ToastTypes.SUCCESS)

          updateDraftCaseId(saveDraftRes.case_draft_id)
          if (userData)
            updateUserData({ ...userData, draft_count: userData.draft_count + 1 })
          getCaseDraftListing()
        }
      }

      if (updateDraftRes) {
        if (updateDraftRes.success) {
          showToast(["Draft updated successfully!!"], ToastTypes.SUCCESS)
          getCaseDraftListing()
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveDraftRes, saveDraftErr, updateDraftRes, updateDraftErr])

  const saveDraftCase = (casePorps: AddCaseProps) => {
    if (saveDraftRes || saveDraftErr) clearSaveDraftData()
    if (updateDraftRes || updateDraftErr) clearUpdateDraftData()

    setLoader()
    updateCaseDraftStatus(true)

    const apiData = {
      draft_json: JSON.stringify(casePorps),
      draft_name:
        casePorps.patient_attributes.dob ?
        `${casePorps.patient_attributes.firstname} ${casePorps.patient_attributes.lastname}, ${casePorps.patient_attributes.dob}`:
        `${casePorps.patient_attributes.firstname} ${casePorps.patient_attributes.lastname}`,
      practice_id: casePorps.doctor_attributes.practice_id,
      user_id: userData?.id,
    }
    if (draftCaseId === 0)
      callAPItoSaveDraft(apiData)
    else
      callAPItoUpdateDraft(apiData, { draftId: draftCaseId })
  }

  return { saveDraftCase, updateDraftLoader, saveDraftLoader };
}
